import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import styles from './styles/styles';

const domElements = document.getElementsByClassName('meldooTicket');
for (let el of domElements) {
	const container = el;

	const dataId = container.getAttribute('data-id');

	const shadowContainer = container.attachShadow({ mode: 'open' });
	const shadowRootElement = document.createElement('div');
	shadowRootElement.id = `mwebTicketShadowRoot_${dataId}`;
	const shadowHeadElement = document.createElement('head');

	const baseStyles = document.createElement('style');
	baseStyles.innerHTML = styles;
	shadowHeadElement.appendChild(baseStyles);

	shadowContainer.appendChild(shadowHeadElement);
	shadowContainer.appendChild(shadowRootElement);

	const cache = createCache({
		key: 'css',
		prepend: false,
		container: shadowHeadElement
	});

	const shadowTheme = createTheme({
		components: {
			MuiPopover: {
				defaultProps: {
					container: shadowRootElement
				}
			},
			MuiPopper: {
				defaultProps: {
					container: shadowRootElement
				}
			},
			MuiModal: {
				defaultProps: {
					container: shadowRootElement
				}
			}
		}
	});

	const root = ReactDOM.createRoot(shadowRootElement);
	root.render(
		<React.StrictMode>
			<CacheProvider value={cache}>
				<ThemeProvider theme={shadowTheme}>
					<App dataKey={container.getAttribute('data-key')} dataId={container.getAttribute('data-id')} headDOM={shadowHeadElement} />
				</ThemeProvider>
			</CacheProvider>
		</React.StrictMode>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
